module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Doster\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Writer and oral historian Stephen Doster was born in Kingston-on-Thames, England, and raised on St. Simons Island, Georgia. He is the author of both fiction and nonfiction, including two oral histories. Doster’s literary works are focused on Georgia and its coast. He holds degrees from the University of Georgia and Vanderbilt University and currently resides in Nashville, Tennessee, with his wife, Anne."), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pwDLj3/tc-custom/9781504078191.jpg?1738354514465",
      "alt": "This image is the cover for the book Her Finest Hour"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Finest Hour\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this WWII memoir, a woman recounts her struggle to survive and serve her country in the Women’s Auxiliary Air Force.")]), _c('br'), _c('br'), _vm._v(" Marjorie Terry Smith was a teenage girl living in the suburbs of London when the Second World War began. Before it was over, her family would be bombed out of three homes, her fiancé would be killed fighting Rommel’s forces in North Africa, and she would join the WAAF. Stationed in the operations rooms on seven different Royal Air Force bases, she encountered RAF legends Douglas Bader and Leonard Cheshire, as well as the indomitable Winston Churchill."), _c('br'), _c('br'), _vm._v(" In "), _c('i', [_vm._v("Her Finest Hour")]), _vm._v(", Smith recounts a youth in England leading up to the war, her six years of service, and life in a recovering England, in which she worked for the British Overseas Airways Corporation as well as the BBC. Vividly recalling how the war changed her life and the world around her, Smith offers a rare insider’s view of WWII military operations from a woman’s perspective, as told to her son, Stephen Doster.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0